// ==========================================
// Filter Enums & Constants
// ==========================================
// This file contains only enums and constants (no React hooks or client code)
// so it can be safely imported into both Server and Client Components

export enum AGE_GROUP_FILTER {
  CHILD = "child",
  ADULT = "adult",
  MIXED = "mixed",
}

export enum DATE_FILTER {
  ANY = "any",
  THIS_WEEK = "this_week",
  NEXT_THIRTY_DAYS = "next_thirty_days",
  NEXT_THREE_MONTHS = "next_three_months",
}

export enum MEMBERSHIP_FILTER {
  IS_ACCEPTING_SIGNUPS = "isAcceptingSignups",
}

export enum CLUB_TYPE_FILTER {
  SPOND_ONLY = "spondOnly",
}

export enum SKILL_LEVEL_FILTER {
  ALL_LEVELS = "all_levels",
  BEGINNER = "beginner",
  INTERMEDIATE = "intermediate",
  ADVANCED = "advanced",
  PROFESSIONAL = "professional",
}

export enum PRICE_FILTER {
  FREE = "free",
  PAID = "paid",
}

// The members that both enums have keep the same string, so saved URLs work.
export enum EVENT_SORT {
  MOST_RELEVANT = "most_relevant",
  UPCOMING_FIRST = "upcoming_first",
  NEWEST_ADDED = "newest_added",
  CLOSEST_TO_ME = "closest_to_me",
  PRICE_LOW_TO_HIGH = "price_low_to_high",
  PRICE_HIGH_TO_LOW = "price_high_to_low",
}

export enum CLUB_SORT {
  CLOSEST_TO_ME = "closest_to_me",
  NEWEST_ADDED = "newest_added",
  NAME_AZ = "name_az",
  NAME_ZA = "name_za",
}

export enum RADIUS_FILTER {
  KM_5 = "5",
  KM_10 = "10",
  KM_25 = "25",
  KM_50 = "50",
  KM_100 = "100",
}

/**
 * Maps RADIUS_FILTER enum values to numeric kilometers.
 * Used to convert URL params to actual radius values.
 */
export const RADIUS_VALUES: Record<RADIUS_FILTER, number> = {
  [RADIUS_FILTER.KM_5]: 5,
  [RADIUS_FILTER.KM_10]: 10,
  [RADIUS_FILTER.KM_25]: 25,
  [RADIUS_FILTER.KM_50]: 50,
  [RADIUS_FILTER.KM_100]: 100,
};

export enum MEMBERSHIP_FEE_FILTER {
  FREE = "free",
  PAID = "paid",
}

export enum CLUB_FILTER_QUERY_KEYS {
  clubType = "clubType",
  ageGroup = "ageGroup",
  skillLevel = "skillLevel",
  membership = "membership",
  membershipFee = "membershipFee",
  date = "date",
  radius = "radius",
  sort = "clubSort",
}

export enum EVENT_FILTER_QUERY_KEYS {
  price = "price",
  // New event-specific filters
  eventSkillLevel = "eventSkillLevel",
  eventAgeGroup = "eventAgeGroup",
  sort = "eventSort",
}
